import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { installSelectFilter } from './app/core/ui/select-filter';

installSelectFilter();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
